//@flow
import * as React from 'react'
import type { InstructionAndDocLink$Props } from './flowTypes'

const InstructionAndDocLink=(props:InstructionAndDocLink$Props)=>{
    return (
        <div className="row">
            <div className="col-sm">
                <a href={'https://docs.google.com/document/d/e/2PACX-1vQ6lBe3EZToUCtEcYvNaO9MhDX-VZljG7kG4pG3pUuHegcNQag694LnX6UTJinG4jhAiw3mxrGjNWsK/pub?embedded=true'} target='_blank' >Instructions</a>
                &nbsp;&nbsp;&nbsp;
                <a href={props.docLink} target='_blank' >PDF Link</a>
                <br />
                <br />
            </div>
        </div> 
    )
}

export default InstructionAndDocLink


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/InstructionAndDocLink.js